export default {"src":"/org/_next/static/media/level.59eb72c0.svg","height":10,"width":10,"blurWidth":0,"blurHeight":0};